// Mode maintenance: bila BE sedang `php artisan down`, semua endpoint membalas 503 dengan
// DATA.maintenance=true. Begitu satu permintaan mana pun menerimanya, seluruh aplikasi diganti
// layar pemeliharaan (App.vue) — tidak ada halaman yang tetap bisa dipakai.
import axios from "axios";
import { reactive } from "vue";

export const maintenance = reactive({ aktif: false });

// Hanya 503 yang membawa penanda dari BE. 503 dari proxy/pihak ketiga tidak ikut dihitung.
export const adalahMaintenance = (error) =>
  error?.response?.status === 503 && error.response.data?.DATA?.maintenance === true;

// Dipasang di instance `api` (interceptors.js) DAN axios bawaan, karena sebagian halaman
// (mis. Education) memanggil axios polos ke gateway yang sama.
export const pasangDeteksiMaintenance = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (adalahMaintenance(error)) maintenance.aktif = true;
      return Promise.reject(error);
    }
  );
};

pasangDeteksiMaintenance(axios);
